import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import Navbar from './Navbar'
import Hero from './Hero'
import Features from './Features'
import Footer from './Footer'

export default function SwimWay() {
  const navigate = useNavigate()

  return (
    <>
      <Navbar navigate={navigate} />

      <Hero navigate={navigate} />

      <Features />

      <Footer />
    </>
  )
}
